import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBCheckBox, DBDropDown } from '_components';
import styles from './Common.module.css'
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';

class PatientCareCenterNotePlanCI extends React.Component {

    handleStudentParticipated(val) {
        if (this.props.studentThno) {
            this.props.clearField(this.props.noteId, 'PTPLAN', 'PLNO', this.props.plno, 'PLSTUDENTTHNO');
        }
    }


    render() {
        if (!this.props.isCI) {
            return (<></>);
        } else {
            return (
                <div>
                    <PatientCareCenterNoteSection id='plan_ci' name='Clinical Instruction' level={1}>
                        <div className={styles.row}>
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='PTPLAN'
                                entityKeyColumn='PLNO'
                                entityKeyValue={this.props.plno}
                                field='PLSTUDENTPARTICIPATED'
                                label="Patient was treated partially or in full by a student."
                                onClick={(val) => this.handleStudentParticipated(val)}
                            />
                        </div>
                        {this.props.studentParticipated &&
                            <div className={styles.row}>
                                <span className={styles.student_label_req}>
                                    Student:
                                </span>
                                <DBDropDown
                                    className={styles.dropdown}
                                    noteId={this.props.noteId}
                                    entity='PTPLAN'
                                    entityKeyColumn='PLNO'
                                    entityKeyValue={this.props.plno}
                                    field='PLSTUDENTTHNO'
                                    customOptions={this.props.students}
                                />
                            </div>
                        }
                    </PatientCareCenterNoteSection>
                </div>
            );
        }
    }

}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch),
    };
}


function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let plno = parseInt(Object.keys(state.entities.notes.PTPLAN)
        .find(key => (state.entities.notes.PTPLAN[key].PLEVNO === pk && noteType === 1)
            || (state.entities.notes.PTPLAN[key].PLNTNO === pk && noteType !== 1)));
    let isCI = state.entities.authentication.user.isCI;
    let studentParticipated = state.entities.notes.PTPLAN[plno].PLSTUDENTPARTICIPATED;
    let studentThno = state.entities.notes.PTPLAN[plno].PLSTUDENTTHNO;

    let students = Object.keys(state.entities.notes.STUDENTLIST)
        .filter(x => { return (state.entities.notes.STUDENTLIST[x].NoteId === noteId); })
        .sort((a, b) => state.entities.notes.STUDENTLIST[a].studentName - state.entities.notes.STUDENTLIST[b].studentName)
        .map(key => ({
            id: state.entities.notes.STUDENTLIST[key].THNO,
            value: state.entities.notes.STUDENTLIST[key].studentName
        }));



    // let students = [
    //     { id: 101, value: 'Test Student 1' },
    //     { id: 102, value: 'Test Student 2' }
    // ];




    return {
        noteId,
        plno,
        isCI,
        students,
        studentParticipated,
        studentThno
    };
}

const connectedPatientCareCenterNotePlanCI = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNotePlanCI);
export { connectedPatientCareCenterNotePlanCI as PatientCareCenterNotePlanCI };

